<footer>
  <div
    class="container"
    fxLayout="row"
    fxLayout.lt-md="column"
    fxLayoutAlign="space-between center"
  >
    <!-- <div fxLayout="row" fxLayoutAlign.lt-md="space-between start">
      <div class="col">{{companyName}}</div>
      <div class="col">SOBRE</div>
      <div class="col">SUPORTE</div>
    </div> -->
    <div>
      {{ companyName }} © {{ initialYearCopy }}-{{ endYearCopy }} Todos os
      direitos reservados.
    </div>
    <div>
      Versão {{ version }} - Developed by NP3 - Ambiente Umov.me:
      {{ umovmeEnvironment.name }}
    </div>
  </div>
</footer>
